import { render, staticRenderFns } from "./siteTime.vue?vue&type=template&id=19baa880&scoped=true"
import script from "./siteTime.vue?vue&type=script&lang=js"
export * from "./siteTime.vue?vue&type=script&lang=js"
import style0 from "./siteTime.vue?vue&type=style&index=0&id=19baa880&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19baa880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19baa880')) {
      api.createRecord('19baa880', component.options)
    } else {
      api.reload('19baa880', component.options)
    }
    module.hot.accept("./siteTime.vue?vue&type=template&id=19baa880&scoped=true", function () {
      api.rerender('19baa880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/siteTime.vue"
export default component.exports